/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
    var $container = $('#projects');
    var endpoint = '/wp-json/wp/v2/projects';
    var template = $('<div class="grid-item"><a href=""><div class="grid-item-content"><figure></figure><figcaption><h2></h2></figcaption></div></a></div>');

    $.fn.scrollView = function () {
        return this.each(function () {
            $('html, body').animate({
                scrollTop: $(this).offset().top
            }, 500);
        });
    };


    function loadPage(params){
        $('#spinner-wrapper').show();
        $.get(endpoint,params,function(newItems, status, xhr){
            var i = 0;
            $('h1').scrollView();
            var totalPages = xhr.getResponseHeader('X-WP-TotalPages');

            var oldItems = $('.grid-item').toArray();
            for(i = 0; i < oldItems.length; i++){
                $container.isotope('remove',$(oldItems[i]));
            }
            for(i = 0; i < newItems.length; i++){
                var j = 0;
                var item = newItems[i];
                var $html = template.clone();
                $html.find('a').attr('href',item.link);
                $html.attr('id',item.id);

                if(typeof item._embedded === 'undefined' ||
                  !item._embedded.hasOwnProperty('wp:featuredmedia') ||
                  item._embedded['wp:featuredmedia'].length === 0){
                    continue;
                }
                if(item['meta-featured'] === 'yes'){
                    $html.addClass('col-sm-8');
                }else{
                    $html.addClass('col-sm-4');
                }

                var img = { file: ''};
                var sizes = item._embedded['wp:featuredmedia'][0].media_details.sizes;
                if(sizes.medium_large){
                    img = sizes.medium_large;
                }else if(sizes.medium){
                    img = sizes.medium;
                }

                $html.find('figure').css('background-image',
                    'url('+img.source_url+')');
                $html.find('h2').html(item.title.rendered);

                var categories = item._embedded['wp:term'];
                if(typeof categories !== 'undefined'){
                    for(j = 0; j < categories.length; j++){
                        $html.addClass(categories[j].slug);
                    }
                }

                $container.isotope('insert', $html);

                var pagination = $('<ul class="pagination"></ul>');
                if(totalPages > 1){
                    for(j = 1; j < parseInt(totalPages) + 1; j++){
                        var pageHtml = $('<li><a href="#'+j+'" data-page="'+j+'"><span class="meta-nav screen-reader-text">Pagina </span>'+j+'</a></li>');
                        if(j === parseInt(params.page)){
                            pageHtml.addClass('active');
                        }
                        pagination.append(pageHtml);
                    }
                }

                $('.pagination').replaceWith(pagination);
                $('#spinner-wrapper').hide();
            }
        });
    }

    $('.slider').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1
                }
            }
        ]
    });

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
            },
            finalize: function() {
                var isMobile = false; //initiate as false
                // device detection
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))){
                    isMobile = true;
                }

                if(!isMobile){
                    var link = $('.call-button a');
                    console.log(isMobile);
                    link.attr('href','#');
                    link.attr('data-toggle','modal');
                    link.attr('data-target','#phoneModal');

                    $('#phoneModal').find('.modal-body').html($('.call-content').html());
                }
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'post_type_archive_bastiaansen_project': {
            init: function() {
                var params = {
                    orderby: 'menu_order',
                    order: 'asc',
                    page: 1,
                    per_page: 8,
                    product_category: [],
                    _embed: true,
                };
                /* activate jquery isotope */
                $container.isotope({
                    itemSelector : '.grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.grid-sizer'
                    },
                    filter: '*'
                });

                loadPage(params);



                $('body').on('click','.pagination a',function(e){
                    e.preventDefault();
                    var page = $(this).attr('data-page');

                    params.page = page;
                    loadPage(params);
                });

                // filter items on button click
                $('#filters').on('click', '.filter-button', function() {
                    var id = $(this).attr('data-id');
                    params.page = 1;
                    if(id === '*'){
                        delete params.product_category;
                    }else{
                        params.product_category = id;
                    }
                    loadPage(params);
                });

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
